import { Icon } from '@fluentui/react';
import React, { useState } from 'react';
import { iconLastProps, iconProps } from '../../utils';

const ActionEditUpdateDelete = ({
  content,
  callBackDelete,
  callBackEdit,
}: any) => {
  const [edit, setEdit] = useState(content.isEdit);

  const onClickCheckMark = () => {
    setEdit(false);

    const newItem = { ...content };
    newItem.isEdit = false;
    callBackEdit(newItem);
  };

  const onClickEdit = () => {
    setEdit(true);

    const newItem = { ...content };
    newItem.isEdit = true;
    callBackEdit(newItem);
  };

  const onClickDelete = () => {
    callBackDelete(content.id);
  };

  return (
    <span>
      <Icon iconName='Delete' styles={iconLastProps} onClick={onClickDelete} />
    </span>
  );

  return edit ? (
    <span>
      <Icon
        iconName='CheckMark'
        styles={iconLastProps}
        onClick={onClickCheckMark}
      />
    </span>
  ) : (
    <span>
      <Icon iconName='Edit' styles={iconProps} onClick={onClickEdit} />
      <Icon iconName='Delete' styles={iconLastProps} onClick={onClickDelete} />
    </span>
  );
};

export default ActionEditUpdateDelete;
